// HostDisplay.tsx
import React, { useContext, useEffect, useState } from 'react';
import { Host } from '../types/Host';
import { UserRoleContext } from '../context/UserRoleContext';
import { getHostById } from '../services/hostService';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

const HostDisplay: React.FC<{}> = () => {

    const { userRole } = useContext(UserRoleContext);
    const host_id = userRole?.host_id;
    const [host, setHost] = useState<Host | null>(null);
    const navigate = useNavigate();



    useEffect(() => {
        if (host_id) {
            const fetchHost = async () => {
                const fetchedHost = await getHostById(host_id);
                if (fetchedHost) {
                    setHost(fetchedHost);
                }
            };
            fetchHost();
        } else if (userRole?.organization_id) {
            navigate(ROUTES.ORGANIZATION_OVERVIEW);
        } else {
            navigate(ROUTES.HOME);
        }
    }, [host_id]);


    if (!host) return null;

    return (
        <div className='card' style={{ maxWidth: 1000 }}>
            <h2><strong>Host Name:</strong> {host.host_name}</h2>
            <h3><strong>Contact Name:</strong> {host.contact_name}</h3>
            <p><strong>Address:</strong> {host.address1}</p>
            <p><strong>Address:</strong> {host.address2 ? host.address2 : ''}</p>
            <p><strong>City:</strong> {host.city}</p>
            <p><strong>State:</strong> {host.state}</p>
            <p><strong>ZIP:</strong> {host.zip}</p>
            <p><strong>Contact Email:</strong> {host.contact_email}</p>
            {/* <div style={styles.container}>
                <p style={styles.text}><strong>Color 1:</strong></p>
                <div style={{ ...styles.roundDiv, backgroundColor: host.color1 }}></div>
            </div>
            <div style={styles.container}>
                <p style={styles.text}><strong>Color 2:</strong></p>
                <div style={{ ...styles.roundDiv, backgroundColor: host.color2 }}></div>
            </div> */}
            {/* <p><strong>Logo:</strong> {host.logo ? <img src={host.logo} alt="Host Logo" style={{ maxWidth: '200px' }} /> : 'No logo available'}</p> */}
            <p><strong>Created At:</strong> {host.created_at ? new Date(host.created_at).toLocaleString() : 'N/A'}</p>
            {userRole?.role_id == 'ADMIN' && <div className='buttonsRow'>
                <div className='buttonsLeft'>
                    <button onClick={() => navigate('/roles')}>Edit Roles for Host</button>
                    <button onClick={() => navigate(ROUTES.UPDATE_HOST)}>Edit Host Details</button>
                    <button style={{ whiteSpace: 'normal' }} onClick={() => navigate(ROUTES.HOST_ORG_OVERVIEW)}>Create New Host</button>
                </div>
            </div>}
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',        // Aligns child elements in a row
        alignItems: 'center',   // Vertically aligns items in the center
        gap: '8px',             // Optional: Adds space between the circle and text
    },
    roundDiv: {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: 'red',
    },
    text: {
        marginTop: '5px',              // Removes default margin for better alignment
    },
};


export default HostDisplay;
